// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectbutton {
    cursor: pointer;
}

    .selectbutton:hover {
        background-color: gray;
    }

.selectbutton > * {
    padding: 0px 16px;
}

.dragitem {
    pointer-events: all;
}

.taskCaption {
    font-size: 18px;
    margin-bottom: 10px
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/workflowwizard/workflow.wizard.settings.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ","sourcesContent":[".selectbutton {\n    cursor: pointer;\n}\n\n    .selectbutton:hover {\n        background-color: gray;\n    }\n\n.selectbutton > * {\n    padding: 0px 16px;\n}\n\n.dragitem {\n    pointer-events: all;\n}\n\n.taskCaption {\n    font-size: 18px;\n    margin-bottom: 10px\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
